import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';
import { get, isEmpty, isNil } from 'lodash';
import { Grid, Typography, Chip } from '@material-ui/core';
import {
  StyledDrawer,
  StyledDrawerHeader,
  StyledDrawerBody,
} from 'containers/CourtManagerAssignedExpertise/style';
import { getValueByCode as getValueByCodeSagis } from 'containers/CourtManagerLegalProceedings/Provision/utils';

import { COLORS } from 'constants/design';
import SelectElement from 'containers/CourtManagerAssignedExpertise/SelectElement';
import TextElement from 'containers/CourtManagerAssignedExpertise/TextElement';
import CloseIconBlack from 'components/SahamIcons/CloseIconBlack';
import { getValueByCode } from 'containers/common/LegalProceedings/JudgementAdd/Recap/utils';
import Victims from 'containers/CourtManagerAssignedExpertise/Victims';
import { translate } from 'containers/services/translate';
import messages from 'containers/CourtManagerAssignedExpertise/messages';
import ConvocationElement from 'containers/CourtManagerAssignedExpertise/Documents/Convocation';
import {
  renderChipLabel,
  renderColor,
} from 'containers/ExpertExpertise/Recap/utils';
import Vehicles from 'containers/CourtManagerAssignedExpertise/Vehicles';
import LetterDesignation from 'containers/CourtManagerAssignedExpertise/Documents/LetterDesignation';
import { VictimType } from 'typings/globalTypes';

interface MissionRecapDrawerProps {
  intl: IntlShape;
  closeDrawer: any;
  mission: any;
  listings: any;
  missionStatus: any;
  requestGetDocByDocumentumId: Function;
}

const MissionRecapDrawer: FC<MissionRecapDrawerProps> = props => {
  const { closeDrawer, mission } = props;
  const { victims, vehicles } = mission;
  const victimNames = victims.map(
    (victim: VictimType) => `${victim.firstName} ${victim.lastName}`,
  );
  const vehiclesRegistrationNumbers = vehicles.map(
    (element: { registrationNumber: string }) =>
      `${element.registrationNumber}`,
  );

  return (
    <StyledDrawer anchor="right" open onClose={closeDrawer}>
      <StyledDrawerHeader>
        <h4>
          {translate(messages.missionTitle, props)} {mission.missionNumber}
        </h4>
        <CloseIconBlack onClick={closeDrawer} />
      </StyledDrawerHeader>
      <StyledDrawerBody>
        <SelectElement
          label={translate(messages.expertiseNature, props)}
          value={mission.typeCode}
          multiple={false}
        />
        {!isEmpty(victimNames) && <Victims names={victimNames} />}
        {!isEmpty(vehiclesRegistrationNumbers) && (
          <Vehicles registrationNumbers={vehiclesRegistrationNumbers} />
        )}

        <TextElement
          label={translate(messages.lawyerAdvice, props)}
          value={getValueByCodeSagis(
            mission.lawyer,
            get(props.listings, 'intervenants'),
          )}
        />
        <SelectElement
          label={translate(messages.expert, props)}
          value={mission.assignedExpert.map((element: any) => ({
            value: element.expertCode,
            title: getValueByCodeSagis(
              element.expertCode,
              get(props.listings, 'intervenants'),
            ),
          }))}
          multiple={true}
        />
        {mission.legalExpert && (
          <TextElement
            label={translate(messages.expertConseilField, props)}
            value={mission.legalExpert}
          />
        )}
        <TextElement
          label={translate(messages.missionDate, props)}
          value={mission.missionDate}
        />
        <TextElement
          label={translate(messages.hour, props)}
          value={mission.lossHour}
        />
        <TextElement
          label={translate(messages.cityName, props)}
          value={mission.city}
        />
        <TextElement
          label={translate(messages.expertiseAddress, props)}
          value={mission.address}
        />
        {mission.receiptDate && (
          <TextElement
            label={translate(messages.receiptDateField, props)}
            value={mission.receiptDate}
          />
        )}

        <SelectElement
          label={translate(messages.procedure, props)}
          value={mission.procedureCode}
          multiple={false}
        />
        {get(mission, 'procedureNatureId', '') &&
        Number(get(mission, 'procedureNatureId', '')) != 3 ? (
          <SelectElement
            label={translate(messages.procedureField, props)}
            value={mission.courtFileNumber}
            multiple={false}
          />
        ) : (
          <></>
        )}
        <SelectElement
          label={translate(messages.step, props)}
          value={mission.stepCode}
          multiple={false}
        />
        <Grid style={{ marginLeft: 20 }}>
          <Grid item>
            <Typography
              style={{
                color: COLORS.LIGHT_GREY,
                fontWeight: 400,
                fontSize: '1rem',
              }}
            >
              {translate(messages.statusTitle, props)}
            </Typography>
          </Grid>
        </Grid>
        {mission.assignedExpert && (
          <>
            {mission.assignedExpert.map(
              /* istanbul ignore next */
              (el: { expertCode: string; reason: string }, i: number) => (
                <>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    style={{ padding: '6px 24px' }}
                    key={i}
                  >
                    <Grid
                      item
                      style={{
                        color: COLORS.TEXT_BLACK,
                        fontWeight: 500,
                        fontSize: '15px',
                      }}
                    >
                      {getValueByCodeSagis(
                        get(el, 'expertCode') as string,
                        get(props.listings, 'intervenants'),
                      ) + ' : '}
                    </Grid>
                    <Grid item xs={11}>
                      <Chip
                        style={{
                          backgroundColor: renderColor(
                            getValueByCode(
                              get(el, 'status') as any,
                              props.missionStatus,
                            ) as any,
                          ),
                          color: COLORS.WHITE,
                          fontWeight: 700,
                        }}
                        label={renderChipLabel(
                          getValueByCode(
                            get(el, 'status') as any,
                            props.missionStatus,
                          ) as any,
                        )}
                      />
                    </Grid>
                  </Grid>
                  {!isNil(get(el, 'reason', null)) && (
                    <>
                      <Grid
                        style={{
                          padding: '12px 24px',
                          color: COLORS.TEXT_BLACK,
                          fontWeight: 400,
                          fontSize: '1rem',
                        }}
                      >
                        {translate(messages.rejectionReason, props)}
                      </Grid>
                      <Grid
                        item
                        style={{
                          color: COLORS.LIGHT_GREY_TEXT,
                          fontWeight: 400,
                          fontSize: '15px',
                          marginLeft: '25px',
                        }}
                      >
                        {get(el, 'reason', null)}
                      </Grid>
                    </>
                  )}
                </>
              ),
            )}
          </>
        )}
        <ConvocationElement
          document={mission.document}
          requestGetDocByDocumentumId={props.requestGetDocByDocumentumId}
        />
        <LetterDesignation mission={mission} listings={props.listings} />
      </StyledDrawerBody>
    </StyledDrawer>
  );
};

export default injectIntl(MissionRecapDrawer);
